import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonComponent, TableSkeletonComponent } from '@dss-libs/shared/ui/common-components';
import { TTableSkeletonColumn } from '@dss-libs/shared/type/common-types';

@Component({
  selector: 'juno-libs-ui-orders-skeleton',
  imports: [SkeletonComponent, TableSkeletonComponent],
  templateUrl: './orders-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdersSkeletonComponent {
  readonly section = input.required<'widget' | 'table'>();

  readonly tableColumns: TTableSkeletonColumn[] = [
    { minWidth: '16rem', lines: ['h-4 w-40', 'h-3 w-32'] },
    { minWidth: '12rem', lines: ['h-4 w-28'] },
    { minWidth: '10rem', lines: ['h-6 w-24 rounded-full!'] },
    { minWidth: '15rem', lines: ['h-4 w-40'] },
    { minWidth: '9rem', lines: ['h-4 w-24'] },
    { minWidth: '4rem', cellClass: 'flex-none w-16 items-center px-3', lines: ['size-6'] },
  ];
}
